import { GetJoinNetworksTable, JoinNetworkData, JoinNetworkTableView, NetworkJoinForm } from 'features/network-join';
import { GetNetworkSelectorSelectList, NetworkSelectorTableView } from 'components/NetworkSelector/types';
import { GetSubscribeNetworksTable, SubscribeNetworkTableView } from 'features/network-subscribe';
import { TableDataResponse } from 'features/types';
import { client, withDataRequest } from 'utils/client';
import { DataResponse, GetSelectList, SelectItem } from './types';
import { DiscoverNetworksTableView, GetDiscoverNetworksTable } from 'features/discover-networks';
import { GetJoinSelectList } from 'features/network-join';
import { Tab, GetSelectListResponse } from 'api/types';

const networksAPI = {
  getJoinTable(params: GetJoinNetworksTable) {
    return client.post<TableDataResponse<JoinNetworkTableView>>('/networks/get-join-table', withDataRequest(params));
  },
  getJoinTableForLeadJobSeeker(params: GetJoinNetworksTable) {
    return client.post<TableDataResponse<JoinNetworkTableView>>('/networks/get-join-table-for-lead-jobseeker', withDataRequest(params));
  },
  getJoinTableForLeadJobSeekerTabsData(params: GetJoinNetworksTable) {
    return client.post<Tab[]>('/networks/get-join-table-tabs-for-lead-jobseeker', withDataRequest(params));
  },
  join(params: NetworkJoinForm, networkId: string) {
    return client.put<void>(`/networks/${networkId}/join`, withDataRequest(params));
  },
  joinForLeadJobSeeker(params: NetworkJoinForm, networkId: string) {
    return client.put<void>(`/networks/${networkId}/join-for-lead-jobseeker`, withDataRequest(params));
  },
  getSubscribeTable(params: GetSubscribeNetworksTable) {
    return client.post<TableDataResponse<SubscribeNetworkTableView>>('/networks/get-subscribe-table', withDataRequest(params));
  },
  getJoinData(networkId: string) {
    return client.get<JoinNetworkData>(`/networks/${networkId}/join-data`);
  },
  getJoinDataForLeadJobSeeker(networkId: string) {
    return client.get<JoinNetworkData>(`/networks/${networkId}/join-data-for-lead-jobseeker`);
  },
  getJoinSelectListForLeadJobSeeker(networkId: string, params: GetJoinSelectList) {
    return client.post<GetSelectListResponse>(`/networks/${networkId}/get-join-select-list-for-lead-jobseeker`, withDataRequest(params));
  },
  getSelectList(params: GetSelectList) {
    return client.post<DataResponse<SelectItem>>(`/networks/get-select-list`, withDataRequest(params));
  },
  getDiscoverTableData(params: GetDiscoverNetworksTable) {
    return client.post<TableDataResponse<DiscoverNetworksTableView>>('/networks/get-discover-table', withDataRequest(params));
  },
  getJobSeekerNetworkSelectorSelectList(params: GetNetworkSelectorSelectList) {
    return client.post<TableDataResponse<NetworkSelectorTableView> | DataResponse<SelectItem>>(`/networks/get-jobseeker-job-network-selector-select-list`, withDataRequest(params));
  },
  getJobSeekerNetworkSelectorTabsData(params: GetNetworkSelectorSelectList) {
    return client.post<Tab[]>('/networks/jobseeker-network-selector-tabs', withDataRequest(params));
  },
};

export default networksAPI;
